import RoundedButton from './RoundedButton';

export default RoundedButton;
